import React from 'react';
import classnames from 'classnames';
import gettext from '@eb/gettext';
import { Button } from '@eb/eds-button';

import { BROWSE_EVENTS_PATH } from '../constants';

const BrowseMoreButton = ({ handleClickBrowseEvents }) => {
    return (
        <div
            className="eds-align--center user-collection__browse-more-button-container"
            style={{ marginTop: '-24px', padding: '80px 0 100px' }}
        >
            <Button
                type="link"
                href={BROWSE_EVENTS_PATH}
                onClick={handleClickBrowseEvents}
            >
                {gettext('Browse other events')}
            </Button>
        </div>
    );
};

export default BrowseMoreButton;
